shadow$provide[324] = function(require,module,exports) {
Object.defineProperties(exports, {__esModule:{enumerable:true, value:true}, RenderFactory:{enumerable:true, get:function() {
  return RenderFactory;
}}});
class RenderFactory {
  constructor(classes, renderer, shaders) {
    this.classes = classes;
    this.renderer = renderer;
    this.shaders = shaders;
  }
  getTypes() {
    return Object.keys(this.classes);
  }
  make(type, options) {
    return new this.classes[type](this.renderer, this.shaders, options);
  }
}

};